import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  // herosection

  heroSectionContainer: {
    position: 'relative',
    backgroundImage: `url(https://d222i9ppxs2fqe.cloudfront.net/faqHeroMobile_opt.jpg)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.up('md')]: {
      backgroundImage: `url(https://d222i9ppxs2fqe.cloudfront.net/faqHero_opt.jpg)`,
    },
  },

  titleWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: '25px 25px',

    [theme.breakpoints.up('md')]: {
      padding: '65px 50px',
    },
  },

  tilte: {
    textShadow: '0px 15px 10px rgba(0, 0, 0, 0.5)',
    [theme.breakpoints.down('sm')]: {
      width: '155px',
    },
  },

  container: {
    padding: '40px 0 10px',
    backgroundColor: theme.palette.whitePepper.main,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '25px',
    },
  },
  innerContainer: {
    margin: '0 auto',
    width: '80%',
    [theme.breakpoints.down('sm')]: {
      width: '85%',
    },
  },
  heading: {
    marginBottom: '40px',
  },
  accordion: {
    borderBottom: theme.palette.cumin.main,
  },
  listWrapper: {
    margin: 0,
  },
  list: {
    '&::marker': {
      color: theme.palette.cumin.main,
    },
  },
  unorderedlist: {
    margin: 0,
  },

  text: {
    marginBottom: '10px',
  },
  needHelp: {
    margin: '50px 0',
    textAlign: 'center',
    '& div': {
      marginBottom: '25px',
    },
    [theme.breakpoints.up('md')]: {
      margin: '75px 0',
    },
  },

  contactUs: {
    width: '100%',
    textAlign: 'center',
    color: 'white',
    backgroundColor: theme.palette.cinnamon.main,
    padding: '25px 0',
    position: 'absolute',
    left: 0,
    fontSize: '21px',
    bottom: '0',
  },

  introductionWrapper: {
    padding: '40px 0px 0px',
  },

  headerContainer: {
    position: 'sticky',
    top: '0px',
    zIndex: '9',
    padding: '20px 25px 25px',
    backgroundColor: theme.palette.whitePepper.main,

    display: 'flex',
    flexShrink: '0',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    overflowX: 'auto',

    [theme.breakpoints.up('sm')]: {
      padding: '30px 50px 25px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '25px 100px 25px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '25px 150px 25px',
    },
  },

  headerTitleWrapper: {
    width: '100%',
    display: 'flex',
    flexShrink: '0',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  contentWrapper: {
    marginBottom: '50px',
  },

  btnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    rowGap: '15px',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      columnGap: '25px',
    },
  },

  feelSection: {
    position: 'sticky',
    bottom: '0px',
    boxShadow: '0px -10px 20px rgba(0, 0, 0, 0.25)',
    zIndex: 11,
  },

  viewPlanBtn: {
    marginTop: '15px',
    width: '200px',
    height: '48px',
    borderRadius: '24px',

    [theme.breakpoints.up('md')]: {
      marginTop: '45px',
      width: '425px',
      height: '75px',
      borderRadius: '55px',
    },
  },
});
